export default __webpack_public_path__ + "static/PlayerFMBig-21345da83bb5cbce5a6c3562594c0964.jpg";